<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1>Acknowledgement</h1>
<p>Our thanks goes to the owners of the Villas in Aubusson (Riverside Cottages). Thank you, Liz and Nic, for welcoming us and making our stay so much easier with your help and useful translations, and organising us with a car during our time in this amazing part of rural France; and for the joy of meeting on Friday nights for a slap up Pommie dinner in your pub!</p>
<p>Marg and Denis</p>
<p>Our day-by-day diary of our three months in Aubusson – rural France – it was an amazing adventure!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005.vue?60da4382